module.exports = __webpack_public_path__ + "img/line-graph-dark.6e01f659.svg";